import PayrollWelfareEditComponents from "../components/WelfareEdit";
import useWelfare from "../hooks/useWelfare";

const PayrollWelfareEdit = () => {
  const useWelfareProps = useWelfare();
  return <PayrollWelfareEditComponents {...useWelfareProps} />;
};

export default PayrollWelfareEdit;
